/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IImageData, IRequestContext, IVideoData } from '@msdyn365-commerce/core';

export enum MediaType {
    /**
     * The None.
     */
    None = 0,
    /**
     * The Image type.
     */
    Image = 1,
    /**
     * The video type.
     */
    Video = 2,
    /**
     * The file type.
     */
    File = 3
}

export interface IMediaData extends IImageData {
    mediaTypeValue?: MediaType;
    displayOrder?: number;
    videoData?: IVideoData;
}

/**
 * Gets correct alt text for image based on configuration of site.
 * @param productName Product name.
 * @param context Current request context.
 * @param imageAltText Alt-text from CMS image.
 */
export function getAltText(
    context: IRequestContext,
    shouldUseCmsAltText: boolean,
    productName?: string,
    imageAltText?: string
): string | undefined {
    if (!context?.app?.config?.OmniChannelMedia) {
        return productName;
    }
    if (shouldUseCmsAltText) {
        return imageAltText;
    }
    return productName;
}
